import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
import loadConfig from "@Web3WalletConfig/config";
export default {
  name: "gift",
  computed: {
    ...walletVuex.mapState(["isMobile", "theme", 'setting'])
  },
  data() {
    return {
      loadConfig,
      isLock: false,
      list: {},
      popRefShow: false,
      popRefStatShow: false,
      modifyData: {},
      isLoading: false
    };
  },
  methods: {
    async getData() {
      this.isLoading = true;
      let rs = await this.$http.post("/referral/list", {});
      this.isLoading = false;
      if (rs.code == 0) {
        this.list = rs.data;
      }
    },
    async onCreate() {
      // let rs = await this.$http.post("/referral/modify",{});
      // if(rs.code == 0){
      //   this.list = rs.data
      // }
      this.modifyData = {
        username: ""
      };
      this.popRefShow = true;
    },
    onModify(item) {
      this.modifyData = item;
      this.popRefShow = true;
    },
    onStat(item) {
      this.modifyData = item;
      this.popRefStatShow = true;
    },
    onRefresh() {
      this.getData();
    }
  },
  mounted() {
    this.getData();
  }
};